

const commonRoutes = [
  {
    path:'/',
    redirect:'/home' //重定向
  },
  {
    path: "/home",
    name: "home",
    meta: {
      title: "东莞招考通"
    },
    component: () => import("@/views/home/home.vue"),
  },
  {
    path: "/getAuditProgress",
    name: "GetAuditProgress",
    meta: {
      title: "学校审核进度"
    },
    component: () => import("@/views/comPage/excel.vue"),
  },
  {
    path: "/customPage",
    name: "customPage",
    meta: {
      title: "自定义页面"
    },
    component: () => import("@/views/comPage/customPage.vue"),
  },
  {
    path: "/comEd",
    name: "comEduHome",
    meta: {
      title: "东莞市义务教育招生掌上通"
    },
    component: () => import("@/views/comPage/comHome.vue"),
  },
  {
    path: "/pdfViewer",
    name: "pdfViewer",
    meta: {
      title: "pdf预览"
    },
    component: () => import("@/views/comPage/pdfViewer.vue"),
  },
];

// 义务教育阶段模块
const eduStageRoutes = [
  // 招生政策
  {
    path: "/comEduStage/admissionPolicy", 
    name: "comAdmissionPolicy", 
    meta: {
      title: "东莞市义务教育市级市镇政策"
    },
    component: () => import("@/views/comEduStage/admissionPolicy.vue"),
  },
  //积分入学
  {
    path: "/comEduStage/integralPolicy", 
    name: "comintegralPolicy",
    meta: {
      title: "东莞市义务教育积分入学"
    },
    component: () => import("@/views/comEduStage/integralPolicy.vue"),
  },
  //招生问答
  {
    path: "/comEduStage/questionAndAnswer",
    name: "comQAndA",
    component: () => import("@/views/comEduStage/questionAndAnswer.vue"),
  },
  {
    path: "/comEduStage/schoolList", 
    name: "comSchoolList",
    meta: {
      title: "学校列表",
      keepAlive:true
    },
    component: () => import("@/views/comEduStage/schoolList.vue"),
  },
  {
    path: "/comEduStage/schoolDetail", 
    name: "comSchoolDetail",
    meta: {
      title: "学校介绍"
    },
    component: () => import("@/views/comEduStage/schoolDetail.vue"),
  },
  {
    path: "/comEduStage/townList", 
    name: "comtownList",
    meta: {
      title: "镇街频道列表"
    },
    component: () => import("@/views/comEduStage/townList.vue"),
  },
  {
    path: "/comEduStage/townDetails", 
    name: "comtownDetails",
    component: () => import("@/views/comEduStage/townDetails.vue"),
  },
  {
    path: "/comEduStage/townPolicy",   
    name: "townPolicy", 
    meta: {
      title: "镇街政策"
    },
    component: () => import("@/views/comEduStage/townPolicy.vue"),
  },
  {
    path: "/comEduStage/townSchoolList", 
    name: "townSchoolList",
    meta: {
      title: "镇街学校"
    },
    component: () => import("@/views/comEduStage/townSchoolList.vue"),
  },
  {
    path: "/comEduStage/townQAndA",
    name: "townQAndA",
    meta: {
      title: "镇街问答"
    },
    component: () => import("@/views/comEduStage/townQAndA.vue"),
  }
];

  // 中考阶段
const midEduStageRoutes = [
  {
    path: "/midEduStage/admissionPolicy",  
    name: "midAdmissionPolicy",
    meta: {
      title: "东莞市中考招生政策"
    },
    component: () => import("@/views/midEduStage/admissionPolicy.vue"),
  },
  {
    path: "/midEduStage/questionAndAnswer",
    name: "midQAndA",
    meta: {
      title: "东莞市中考招生问答"
    },
    component: () => import("@/views/midEduStage/questionAndAnswer.vue"),
  },
   //学校列表
  {
    path: "/midEduStage/schoolList",  
    name: "midSchoolList",
    meta: {
      title: "学校列表"
    },
    component: () => import("@/views/midEduStage/schoolList.vue"),
  },
  //学校详情
  {
    path: "/midEduStage/schoolDetail",
    name: "midSchoolDetail",
    component: () => import("@/views/midEduStage/schoolDetail.vue"),
  },
  //学校介绍
  {
    path: "/midEduStage/schoolInfo",
    name: "midSchoolInfo",
    component: () => import("@/views/midEduStage/schoolInfo.vue"),
  },
  //招生详情
  {
    path: "/midEduStage/zsDetails",
    name: "midZsDetails",
    component: () => import("@/views/midEduStage/zsDetails.vue"),
  },
  //学校相册
  {
    path: "/midEduStage/schoolAlbum",
    name: "midSchoolAlbum",
    component: () => import("@/views/midEduStage/schoolAlbum.vue"),
  },
  //学校视频
  {
    path: "/midEduStage/schoolVideo",
    name: "midSchoolVideo",
    component: () => import("@/views/midEduStage/schoolVideo.vue"),
  },
  //专业列表
  {
    path: "/midEduStage/majorsList",
    name: "midMajorsList",
    component: () => import("@/views/midEduStage/majorsList.vue"),
  },
  // 专业详情
  {
    path: "/midEduStage/majorsDetails",
    name: "midMajorsDetails",
    component: () => import("@/views/midEduStage/majorsDetails.vue"),
  },
  // 莞校志
  {
    path: "/midEduStage/allSchoolVideo",
    name: "midAllSchoolVideo",
    meta: {
      title: "莞校志"
    },
    component: () => import("@/views/midEduStage/allSchoolVideo.vue"),
  },
];

export default [...commonRoutes, ...eduStageRoutes, ...midEduStageRoutes];
